import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GlobalService } from '../../services/global.service';
import { MLService } from '../../services/ml-service';
import { WorkflowService } from '../../services/workflow-service';
import { AlertComponent } from '../../common/alert/alert.component';
import { TenantService } from '../../services/tenant.service';
import { MatTableDataSource } from '@angular/material/table';
import { ioParameter } from '../../models/ioparameters.model';
import { customFunction } from '../../models/custom-function.model';

@Component({
  selector: 'app-custom-function-builder',
  templateUrl: './custom-component-builder.html',
  styleUrls: ['./custom-component-builder.css']
})

export class CustomComponentBuilder implements OnInit {
  inputItems = [];
  inputTextItems = [];
  outputItems = [];
  outputTextItems = [];
  regProgress = true;
  invalidParameter:boolean = true;
  selectedStep = 0;
  availModelErro = '';
  registrationName = '';
  functionDescription = '';
  selectedImageName = '';
  isInputParameters = true;
  activeParam: number = 0;
  selectedComponentName = "";
  dupCapInParam = [];
  availableFunctionList = [];
  captionExist = true;
  dupCapOutParam = [];
  validCapInParam = [];
  validCapOutParam = [];
  selectedComponentType: any = { registrationName: '' } ;
  imageToUpload: File = null;
  public methodList: string[];
  functionMethod = null;
  functionName: string;
  functionUrl: any;

  isOauthClientAndSecret = false;
  isOauthManagedIdentity = false;
  authRequired = null;
  valueDuplicate: boolean = false;
  subscriptionKey: any = '';
  subscriptionValue: any = '';
  clientIdName : any = '';
  clientIdNameValue : any = '';
  secretName : any = '';
  secretNameValue : any = '';
  scopeKeyName : any = '';
  scopeKeyValue : any = '';

  urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
  );
  public inputParameters: MatTableDataSource<ioParameter>;
  public outputParameters: MatTableDataSource<ioParameter>;
  public modelData = new customFunction();
  public displayedColumns: string[] = ["parameterName", "captionName", "action"];
  response: any[];
  dataToSend: { 
    TenantId: number; 
    Method: any; 
    Name: any; 
    ComponentType: string; 
    ApiUrl: any; 
    businessDescription: any;
    refinaryName: any;
    CreatedBy: any; 
    LastUpdatedBy: any;
    ComponentId: any;
    ComponentImage: any;
    InputParameters: { ComponentName: string; CaptionName: string; ParameterName: string;  }[]; 
    OutputParameters: { ComponentName: string; CaptionName: string; ParameterName: string;  }[]; 
    AuthId: number;
    SubscriptionKeyName: any;
    subscriptionKeyValue: any;
    ClientKeyName: any;
    ClientKeyValue: any;
    SecretKeyName: any;
    SecretKeyValue: any;
    ScopeKeyName: any;
    ScopeKeyValue: any;
  };
  nameDuplicate: boolean = false;
  ComponentId: any;
  isUrlReadOnly: boolean = true;
  paramDuplicate: boolean = false;
  captionDuplicate: boolean = false;
  inputParamDuplicate: boolean;
  inputCaptionDuplicate: boolean;
  outputParamDuplicate: boolean;
  outputCaptionDuplicate: boolean;
  dataUpdated: boolean = true;
  nameValid: boolean = true;
  oauthAuthenticationList = [];
  isSecretAvailable: any;
  isScopeAvailable: any;
  isSubscriptionAvailable: any;
  isClientAvailable: any;
  secretList: any = [];

  constructor(public dialogRef: MatDialogRef<CustomComponentBuilder>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: GlobalService,
    public mlService: MLService,
    public workflowService: WorkflowService,
    public tenantService: TenantService,
    public dialog: MatDialog) {
  };

  ngOnInit() {
    this.regProgress = true;
    this.methodList = ["Post", "Get"];
    this.dialogRef.disableClose = true;
    this.inputParameters = new MatTableDataSource([new ioParameter()]);
    this.outputParameters = new MatTableDataSource([new ioParameter()]);
    this.checkIfEdit(this.data);
    this.getAllSecretsList();
    this.getAuthDetailsList();
  }

  getAuthDetailsList() {
    this.mlService.getAuthDetailsList().subscribe((data: any): void => {
      if (data.length > 0) {
        this.oauthAuthenticationList = data;
      }
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  checkIfEdit(dataForEdit) {
    if (dataForEdit.customFunctionData && (dataForEdit.actionType == "editFunction" || dataForEdit.actionType == "viewFunction")) {
      let selectedCustomFunction = dataForEdit.customFunctionData;
      if (selectedCustomFunction && selectedCustomFunction !== null && selectedCustomFunction !== undefined) {
        this.functionName = selectedCustomFunction.name;
        this.functionDescription = selectedCustomFunction.businessDescription;
        this.functionMethod = selectedCustomFunction.method;
        this.functionUrl = selectedCustomFunction.apiUrl;
        this.authRequired = selectedCustomFunction.authId;

        if (selectedCustomFunction.authId === 1) {
          this.isOauthClientAndSecret = true;
          this.subscriptionKey = selectedCustomFunction.subscriptionKeyName;
          this.subscriptionValue = selectedCustomFunction.subscriptionKeyValue;
          this.clientIdName = selectedCustomFunction.clientKeyName;
          this.clientIdNameValue = selectedCustomFunction.clientKeyValue;
          this.secretNameValue = selectedCustomFunction.secretKeyValue;
          this.secretName = selectedCustomFunction.secretKeyName;
          this.scopeKeyName = selectedCustomFunction.scopeKeyName;
          this.scopeKeyValue = selectedCustomFunction.scopeKeyValue;
        } else if(selectedCustomFunction.authId === 2) {
          this.isOauthManagedIdentity = true;
          this.subscriptionKey = selectedCustomFunction.subscriptionKeyName;
          this.subscriptionValue = selectedCustomFunction.subscriptionKeyValue;
          this.scopeKeyName = selectedCustomFunction.scopeKeyName;
          this.scopeKeyValue = selectedCustomFunction.scopeKeyValue;
        }

        if(dataForEdit.actionType == "viewFunction") this.isUrlReadOnly = false;
        this.isInputParameters = true;
        this.inputParameters = new MatTableDataSource([new ioParameter()]);
        this.outputParameters = new MatTableDataSource([new ioParameter()]);

        let selectedInputData = selectedCustomFunction.inputParameters;
        let inputParamList = selectedInputData.map(v => ({
          componentName: this.functionName, captionName: v.captionName, parameterName: v.parameterName,
          parameterId: 0, parameterDefaultValue: 0, parameterDataType: '', parameterUom: '', uomType: ''
        }
        ));
        this.modelData.inputParameters = inputParamList;

        let selectedOutputData = selectedCustomFunction.outputParameters;
        let outputParamList = selectedOutputData.map(v => ({
          componentName: this.functionName, captionName: v.captionName, parameterName: v.parameterName,
          parameterId: 0, parameterDefaultValue: 0, parameterDataType: '', parameterUom: '', uomType: ''
        }
        ));
        this.modelData.outputParameters = outputParamList;
        this.regProgress = false;
      }
    }
    else{
      this.regProgress = false;
    }
  }
  
  selectionChange(selelctedStep) {
    this.selectedStep = selelctedStep;
  }

  stepChange(event) {
    this.regProgress = false;
    this.isInputParameters = true;
    this.activeParam = 0;
    this.loadTableData();
  }

  /**Loads table data */
  loadTableData() {
    this.regProgress = true;
    if(this.data.actionType == "addFunction"){
      this.modelData.inputParameters = this.inputParameters.data;
      this.modelData.outputParameters = this.outputParameters.data;
    }
    else{
      this.inputParameters.data = this.modelData.inputParameters;
      this.outputParameters.data = this.modelData.outputParameters;      
    }
    this.regProgress = false;
  }

  configureIt(index) {
    this.activeParam = index;    
  }

  getURLTooltip(){
    return this.functionUrl
  }

  selectParamType(paramType, inputTabSelected) {
    if (inputTabSelected !== this.isInputParameters) {
      this.activeParam = 0;
    }
    
    if (paramType === 'input') {
      this.isInputParameters = true;
    } else {
      this.isInputParameters = false;
    }
  }

  validateCaption(event, activeIndex, dupType, nameType, parameters) {
    if (event.target.value) {
      const nameRGEX = new RegExp('^[A-Za-z0-9][A-Za-z0-9_.-]*');
      let latest = event.target.value;
      let nameExisiting;
      let nameValid = true;
      dupType[activeIndex] = false;
      nameType[activeIndex] = false;
      nameExisiting = parameters.filter((m, index) => {
        if (index !== activeIndex) {
          return m.captionName == latest;
        }
      });
      this.captionExist = nameExisiting.length > 0;
      if (!this.captionExist) {
        nameValid = nameRGEX.test(latest);
      }
      nameType[activeIndex] = !nameValid;
      dupType[activeIndex] = nameExisiting.length > 0;
    }
  }

  handleModelImageInput(imageFile: File) {
    this.imageToUpload = imageFile;
    this.selectedImageName = this.imageToUpload.name;
    this.invalidParameter = false;
  }

  validateFirstStep(){
    let IsFirstStepInvalid = true;
    if(!this.nameValid || this.nameDuplicate || !this.functionDescription || !this.functionMethod || !this.functionUrl || !this.authRequired) {
      return IsFirstStepInvalid;
    } else {
      IsFirstStepInvalid = false;
      
      if (this.authRequired == 1) {
        if (this.subscriptionKey == '' || this.subscriptionValue == '' || this.clientIdName == '' || this.clientIdNameValue == '' || this.secretName == '' ||
          this.secretNameValue == '' || this.scopeKeyName == '' || this.scopeKeyValue == '') {
          IsFirstStepInvalid = true;
        }
      } else if(this.authRequired == 2) {
        if (this.subscriptionKey == '' || this.subscriptionValue == '' || this.scopeKeyName == '' || this.scopeKeyValue == '') {
          IsFirstStepInvalid = true;
        }
      }
      return IsFirstStepInvalid;
    }    
  }

  validateName(event: any) {
    if (event.target.value !== '') {
      const nameRGEX = new RegExp('^[a-zA-Z0-9]{4,60}$');
      this.nameValid = nameRGEX.test(this.functionName);
      this.nameDuplicate = false
      if(this.nameValid){
        let nameValue = this.functionName;
        let duplicateExists = this.data.customNameList.filter(obj => obj == nameValue);
        this.nameDuplicate = (duplicateExists.length > 0) ? true : false;
      }
    }
    else {
      this.nameDuplicate = false
    }
  }

  validateBeforeUpdate(event: any) {
    if (event.target.value && event.target.value !== '' && this.data.customFunctionData) {
      let latest = event.target.value;
      let businessDescriptionExisting = this.data.customFunctionData.businessDescription;
      let methodExisting = this.data.customFunctionData.method;
      let apiUrlExisting = this.data.customFunctionData.apiUrl;

      if (businessDescriptionExisting != latest || methodExisting != latest || apiUrlExisting != latest) {
        this.invalidParameter = false; // this will enable Save button if form elements are modified by user
      }
      
      let secretNameExisting = this.data.customFunctionData.secretKeyName;
      let secretNameValueExisting = this.data.customFunctionData.secretKeyValue;
      let subscriptionKeyExisting = this.data.customFunctionData.subscriptionKeyName;
      let subscriptionValueExisting = this.data.customFunctionData.subscriptionKeyValue;
      let clientIdNameExisting = this.data.customFunctionData.clientKeyName;
      let clientIdNameValueExisting = this.data.customFunctionData.clientKeyValue;
      let scopeNameExisting = this.data.customFunctionData.scopeKeyName;
      let ScopeKeyValueExisting = this.data.customFunctionData.scopeKeyValue;

      if (secretNameExisting != latest
        || secretNameValueExisting != latest
        || subscriptionKeyExisting != latest
        || subscriptionValueExisting != latest
        || clientIdNameExisting != latest
        || clientIdNameValueExisting != latest
        || scopeNameExisting != latest
        || ScopeKeyValueExisting != latest
      ) {
        this.invalidParameter = false; // this will enable Save button if parameter is modified by user
      }
    }
  }

  keyUniqueCheck(key) {
    if (key === 'secretKey') {
      
      this.isSecretAvailable = this.secretList.some(item => item.toLowerCase() === this.secretName.toLowerCase());
      if (!this.isSecretAvailable && (this.secretName.toLowerCase() == this.subscriptionKey.toLowerCase() || this.secretName.toLowerCase() == this.scopeKeyName.toLowerCase() || this.secretName.toLowerCase() == this.clientIdName.toLowerCase())) {
        this.isSecretAvailable = true;
      }
    }
    else if (key === 'scopeKeyName') {
      
      this.isScopeAvailable = this.secretList.some(item => item.toLowerCase() === this.scopeKeyName.toLowerCase());
      if (!this.isScopeAvailable && (this.scopeKeyName.toLowerCase() == this.subscriptionKey.toLowerCase() || this.scopeKeyName.toLowerCase() == this.secretName.toLowerCase() || this.scopeKeyName.toLowerCase() == this.clientIdName.toLowerCase())) {
        this.isScopeAvailable = true;
      }
    }
  }

  secretNameCheck(key) {
    if (key === 'subscriptionKey') {

      this.isSubscriptionAvailable = this.secretList.some(item => item.toLowerCase() === this.subscriptionKey.toLowerCase());
      if (!this.isSubscriptionAvailable && (this.subscriptionKey.toLowerCase() == this.scopeKeyName.toLowerCase() || this.subscriptionKey.toLowerCase() == this.secretName.toLowerCase() || this.subscriptionKey.toLowerCase() == this.clientIdName.toLowerCase())) {
        this.isSubscriptionAvailable = true;
      }
    }
    else if (key === 'clientKey') {

      this.isClientAvailable = this.secretList.some(item => item.toLowerCase() === this.clientIdName.toLowerCase());
      if (!this.isClientAvailable && (this.clientIdName.toLowerCase() == this.subscriptionKey.toLowerCase() || this.clientIdName.toLowerCase() == this.secretName.toLowerCase() || this.clientIdName.toLowerCase() == this.scopeKeyName.toLowerCase())) {
        this.isClientAvailable = true;
      }
    }
  }

  getAllSecretsList() {
    this.mlService.getAllSecretsList().subscribe((data: any): void => {
      if (data.length > 0) {
        this.secretList = data;
      }
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  setInputParameters(isInput: boolean) {
    this.isInputParameters = isInput;
  }

  validateParameter() {
    if (this.isInputParameters) {
      this.checkDuplicateParam(this.modelData.inputParameters, 'input', 'parameterName');
      this.checkDuplicateParam(this.modelData.inputParameters, 'input','captionName');
      this.invalidParameter = (this.inputParamDuplicate || this.inputCaptionDuplicate) ? true : false;
    }
    else {
      this.checkDuplicateParam(this.modelData.outputParameters, 'output','parameterName');
      this.checkDuplicateParam(this.modelData.outputParameters, 'output','captionName');
      this.invalidParameter = (this.outputParamDuplicate || this.outputCaptionDuplicate) ? true : false;
    }
  }

  checkDuplicateParam(paramList, paramType, nameType){
    if (nameType == 'parameterName') {
      let paramArr = paramList.map(function (item) { return item.parameterName });
      let nameValueDuplicate = paramArr.some(function (item, idx) {
        return paramArr.indexOf(item) != idx
      });
      this.checkNameValidate(nameValueDuplicate, paramType);
    } else {
      let captionArr = paramList.map(function (item) { return item.captionName });
      let captionValueDuplicate = captionArr.some(function (item, idx) {
        return captionArr.indexOf(item) != idx
      });
      this.checkCaptionValidate(captionValueDuplicate, paramType);
    }
  }

  checkNameValidate(nameValueDuplicate, paramType) {
    if (nameValueDuplicate && paramType === 'input') {
      this.inputParamDuplicate = true;
    } else if (!nameValueDuplicate && paramType === 'input') {
      this.inputParamDuplicate = false;
    } else if (nameValueDuplicate && paramType === 'output') {
      this.outputParamDuplicate = true;
    } else if (!nameValueDuplicate && paramType === 'output') {
      this.outputParamDuplicate = false;
    }
  }

  checkCaptionValidate(captionValueDuplicate, paramType){
    if (captionValueDuplicate && paramType === 'input') {
      this.inputCaptionDuplicate = true
    } else if (!captionValueDuplicate && paramType === 'input') {
      this.inputCaptionDuplicate = false
    } else if (captionValueDuplicate && paramType === 'output') {
      this.outputCaptionDuplicate = true
    } else if (!captionValueDuplicate && paramType === 'output') {
      this.outputCaptionDuplicate = false
    }
  }

  displayAddParameters(index: number) {
    let check: boolean;
    if (this.isInputParameters) {
      check = (index == this.inputParameters.data.length - 1);
    } else {
      check = (index == this.outputParameters.data.length - 1);
    }
    return check;
  }

  addNewParameter() {
    if (this.isInputParameters) {
      let iParam = this.inputParameters.data;
      iParam.push(new ioParameter());
      this.inputParameters = new MatTableDataSource(iParam);
      this.invalidParameter = true;
    } else {
      let oParam = this.outputParameters.data;
      oParam.push(new ioParameter());
      this.outputParameters = new MatTableDataSource(oParam);
      this.invalidParameter = true;
    }
  }

  deleteModel(index: number) {
    if (this.isInputParameters) {
      if (this.inputParameters.data.length == 1) {
        let iParam = this.inputParameters.data;
        iParam.push(new ioParameter);
        this.inputParameters = new MatTableDataSource(iParam);
        this.invalidParameter = true;
      }
      let iParam = this.inputParameters.data;
      iParam.splice(index, 1);
      this.inputParameters = new MatTableDataSource(iParam);
      let inputpara = this.inputParameters.data.filter(a => a.parameterName.length == 0);
      if (inputpara.length > 0) {
        this.invalidParameter = true;
      }
      else {
        this.invalidParameter = false;
      }

    } else {
      if (this.outputParameters.data.length == 1) {
        let iParam = this.outputParameters.data;
        iParam.push(new ioParameter());
        this.outputParameters = new MatTableDataSource(iParam);
        this.invalidParameter = true;
      }

      let oParam = this.outputParameters.data;
      oParam.splice(index, 1);
      this.outputParameters = new MatTableDataSource(oParam);
      let outputpara = this.outputParameters.data.filter(a => a.parameterName.length == 0);
      if (outputpara.length > 0) {
        this.invalidParameter = true;
      }
      else {
        this.invalidParameter = false;
      }
    }
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

/**Check for enabling/disabling Save button */
disableSave() {
  let check: boolean;
  if (!check) {
    let inputName = this.inputParameters?.data.map(d => d.parameterName);
    let inputCaption = this.inputParameters?.data.map(d => d.captionName);
    let outputName = this.outputParameters?.data.map(d => d.parameterName);
    let outputCaption = this.outputParameters?.data.map(d => d.captionName);

    let iParam: boolean = !this.globals.isNotNullObject(this.inputParameters)
      || (this.globals.isNotNullObject(this.inputParameters) && (inputName.includes("") || inputCaption.includes("")));

    let oParam: boolean = !this.globals.isNotNullObject(this.outputParameters)
      || (this.globals.isNotNullObject(this.outputParameters) && (outputName.includes("") || outputCaption.includes("")));
    check = iParam || oParam;
  }
  return check;
}

  onOauthSelected() {
    let selectedOauth = this.authRequired;
   
    if (selectedOauth === 1) {
      this.isOauthClientAndSecret = true;
      this.isOauthManagedIdentity = false;      
    } else if (selectedOauth === 2) {
      this.isOauthManagedIdentity = true;
      this.isOauthClientAndSecret = false;
      
    } else {
      this.isOauthClientAndSecret = false;
      this.isOauthManagedIdentity = false;      
    }
    
  }

  onSubmit() {
    this.regProgress = true;
    
    let inputParamData = this.inputParameters.data;
    let inputParamList = inputParamData.map(v => ({
        ComponentName: this.functionName,
        CaptionName: v.captionName,
        ParameterName: v.parameterName,
        parameterDefaultValue: this.data.actionType == "editFunction" ? v.parameterDefaultValue : 0
      }
    ));
    
    let outputParamData = this.outputParameters.data;
    let outputParamList = outputParamData.map(v => ({
        ComponentName: this.functionName,
        CaptionName: v.captionName,
        ParameterName: v.parameterName,
        parameterDefaultValue: this.data.actionType == "editFunction" ? v.parameterDefaultValue : 0
      }
    ));

    if (this.data.actionType == "editFunction") {
      this.ComponentId = this.data.customFunctionData.componentId
    } else {
      this.ComponentId = 0;
    }
    this.dataToSend =
    {
      "TenantId": this.tenantService.getCurrentTenant().tenantId,
      "Method": this.functionMethod,
      "Name": this.functionName,
      "ApiUrl": this.functionUrl,
      "businessDescription": this.functionDescription,
      "refinaryName": this.tenantService.getCurrentTenant().tenantRefinery,
      "ComponentType":"Function",
      "CreatedBy": this.globals.loggedInUser,
      "LastUpdatedBy": this.globals.loggedInUser,
      "ComponentId": this.ComponentId,
      "ComponentImage": "",
      "InputParameters": inputParamList,
      "OutputParameters": outputParamList,
      "AuthId": this.authRequired,
      "SubscriptionKeyName": this.subscriptionKey,
      "subscriptionKeyValue": this.subscriptionValue,
      "ClientKeyName": this.clientIdName,
      "ClientKeyValue": this.clientIdNameValue,
      "SecretKeyName": this.secretName,
      "SecretKeyValue": this.secretNameValue,
      "ScopeKeyName": this.scopeKeyName,
      "ScopeKeyValue": this.scopeKeyValue,
    }
    const formData: FormData = new FormData();
    formData.set('data', JSON.stringify(this.dataToSend));
    if (this.imageToUpload != null) {
      formData.set('modelImage', this.imageToUpload, this.imageToUpload.name);
    }
    
    if(typeof this.dataToSend.TenantId !== 'undefined'){
      this.workflowService.saveFinalFunctionData(formData).subscribe((response: any): void => {
        this.regProgress = false;
        let messageText = this.data.edit ? 'updated' : 'saved';
        this.globals.showAlert(AlertComponent, { success: true, message: "Custom Function " + messageText + " successfully!" });
        this.dialogRef.close(true);
      },
        error => {
          this.globals.showAlert(AlertComponent, { success: false, message: "Error while saving data!" });
          this.regProgress = false;
       });
    }    
  }

}
